import { render } from "./NoLicenseModal.vue?vue&type=template&id=7d6f3a20"
import script from "./NoLicenseModal.vue?vue&type=script&lang=js"
export * from "./NoLicenseModal.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/gilcode.com/kwordz.gilcode.com/packages/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__